import { render } from "./pagination_details.vue?vue&type=template&id=cdedeade&lang=pug"
import script from "./pagination_details.vue?vue&type=script&lang=js"
export * from "./pagination_details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__